<template lang='pug'>
  div
    v-toolbar(dense)
      bionic-metrics-create-dashboard(ref='createDashboard')
      bionic-metrics-sort-order(v-model='dashboards')
    bionic-metrics-page-loading(v-if='loading')
    bionic-metrics-number
    v-container#summary(fluid v-if='!loading').pb-1
      v-row(dense)
        v-col(cols='12' md='6' lg='3' v-for='dashboard in dashboards' :key='dashboard.guid')
          bionic-metrics-summary-card(:dashboard='dashboard' @delete='deleteDashboard')
</template>

<script>
import {mapGetters} from 'vuex';
import BionicMetricsNumber from '../../components/Number';
import BionicMetricsPageLoading from '../../components/PageLoading';
import BionicMetricsSortOrder from '../../components/SortOrder';
import BionicMetricsCreateDashboard from '../../components/CreateDashboard';
import BionicMetricsSummaryChart from '../../components/SummaryChart';
import BionicMetricsSummaryCard from '../../components/SummaryCard';
import Summary from '../../api/summary';
import Dashboard from '../../api/dashboard';
import Notifications from '../../services/notification.service';

export default {
  components: {
    BionicMetricsSummaryCard,
    BionicMetricsSummaryChart,
    BionicMetricsCreateDashboard,
    BionicMetricsSortOrder,
    BionicMetricsPageLoading,
    BionicMetricsNumber
  },
  name: 'Summary',
  async mounted() {
    await this.load();
  },
  computed: {
    ...mapGetters({
      user: 'getUser',
      account: 'getAccount'
    })
  },
  methods: {
    async load() {
      try {
        this.loading = true;
        const {list, total} = await Summary.get();
        this.dashboards = list;
        this.total = total;
      } catch (error) {
        console.error(`Problem getting dashboards: ${error.toString()}`);
        Notifications.errorToast('Error Loading Summary', {duration: 30000, retry: this.load});
      } finally {
        this.loading = false;
      }
    },
    async deleteDashboard(dashboard) {
      if (dashboard.primary) return Notifications.alert('You cannot delete the primary dashboard');
      if (!(await Notifications.confirm('Delete', `Are you sure you want to delete <strong>${dashboard.name}</strong> dashboard?`))) return;
      await Dashboard.remove(dashboard.guid);
      this.$delete(this.dashboards, this.dashboards.findIndex((d) => d.guid === dashboard.guid));
      Notifications.toast(`<strong>${dashboard.name}</strong> dashboard deleted`);
    },
    openCreate() {
      this.$refs.createDashboard.open();
    }
  },
  data() {
    return {
      loading: false,
      dashboards: null,
      total: null
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
